import { render, staticRenderFns } from "./SortDropdown.vue?vue&type=template&id=ae41e764&"
import script from "./SortDropdown.vue?vue&type=script&lang=js&"
export * from "./SortDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SortDropdown.vue?vue&type=style&index=0&id=ae41e764&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports